const initialEditorState = {
  firstName: '',
  lastName: '',
  secoundName: '',
  phone: '',
  mobilePhone: '',
};

export default initialEditorState;
